<template lang="pug">
el-collapse#card-dados-territorio(v-model='collapse')
    el-collapse-item.pb-0(name='item')
        header.p-2(slot='title')
            .esquerda
                span {{ index + 1 }}
                h3 {{ territorio.nome }}
                span.erro(v-if='$v.dados.$invalid') *

            .direita
                h3.mr-2.p-1 {{ territorio.localidade }}
                BaseButton.buttonLaudoDanger(
                    type='danger',
                    icon='el-icon-delete',
                    @click='$emit("removerTerritorio", territorio.id)'
                )

        .box
            span.descritivo.bold {{ $t('mensagens.laudos.selecioneAbaixoOCarVinculadoAoTerritorioParaQualDesejaLaudoCasoSelecionadoMaisDeUmRegistro') }}

            .options
                label.item(v-for='car in territorio.cars', :key='car.id')
                    .divisao
                        | CAR
                        .selecionar-car
                            el-checkbox(
                                :id='"chk-" + car.id',
                                :key='car.id',
                                :checked='territorio.cars.length === 1'
                                @change='addToLaudos(car.id, territorio.id, car.codigo)'
                            ) {{ car.codigo }}
            span.descritivo {{ $t('mensagens.laudos.casoCarDesejadoNaoEstejaNaListagem') }}
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validators from '@/utils/validators';
import TipoLaudo from '@/constants/TipoLaudo';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'CardDadosTerritorioRenovabio',

    components: {
        BaseButton
    },

    emits: ['removerTerritorio', 'getDados', 'getValidacao'],

    props: {
        territorio: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        valido: {
            type: Boolean,
            default: false
        }
    },

    created() {
        this.onLoad();
    },

    data() {
        return {
            collapse: ['item'],
            laudos: []
        };
    },

    mounted() {
        this.$emit('getValidacao', {
            valido: !this.$v.dados.$invalid,
            id: this.territorio.id
        });
    },

    watch: {
        '$v.dados.$invalid': function () {
            this.$emit('getValidacao', {
                valido: !this.$v.dados.$invalid,
                id: this.territorio.id
            });
            this.$emit('getDados', {
                dados: this.laudos,
                id: this.territorio.id
            });
        }
    },

    validations: {
        laudos: { required },
        dados: ['laudos']
    },

    methods: {
        addToLaudos(idCar, idTerritorio, codigoCar) {
            let checked = $('#chk-' + idCar + ' input:checkbox').is(':checked');

            this.updateLaudos(idCar, idTerritorio, codigoCar, checked);
        },

        updateLaudos(idCar, idTerritorio, codigoCar, checked) {
            if (checked) {
                if (this.laudos.length > 0) {
                    this.laudos = this.laudos.filter(l => !(l.territorioId === idTerritorio && l.carId === idCar));
                }

                this.laudos.push({
                    territorioId: idTerritorio,
                    carId: idCar,
                    codigoCar: codigoCar,
                    tipoLaudoId: TipoLaudo.RENOVABIO
                });

            } else {
                this.laudos = this.laudos.filter(
                    l => !(l.territorioId === idTerritorio && l.carId === idCar)
                );
            }
            this.$emit('getDados', {
                dados: this.laudos,
                id: this.territorio.id
            });
        },

        documentoValido(documento) {
            if (documento) return validators.validarDocumento(documento);

            return false;
        },

        onLoad() {
            if (this.territorio.cars.length === 1) {
                this.updateLaudos(this.territorio.cars[0].id, this.territorio.id, this.territorio.cars[0].codigo, true);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#card-dados-territorio {
    background-color: var(--white);
    border-radius: 4px;
    overflow: hidden;
    width: 100% !important;

    header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0 !important;

        .esquerda,
        .direita {
            display: flex;
            align-items: center;
            justify-content: space-between;

            gap: 4px;
        }

        .esquerda {
            span {
                color: var(--gray);
                font-size: 12px;
            }
        }

        .direita {
            h3 {
                background-color: var(--default-border-color);
                border-radius: 4px;
            }
        }
    }

    .box {
        padding: 1rem 1.5rem;
        border-top: 1px solid var(--default-border-color);
    }
}

.erro {
    color: red !important;
}

.descritivo {
    font-size: 14px;
}

.bold {
    font-weight: 500;
}

.options {
    margin: 1.5rem 0;
    display: flex;
    flex-wrap: wrap;
}

.item {
    overflow: auto;
    width: 100%;
    display: flex;
    color: #00413c;
}

.divisao {
    width: 400px;
    min-width: 400px;
}
</style>
